"use strict";
(function () {
    function isAccessibleClick (event) {
        if (event.type === 'click') {
            return true;
        } else if (event.type === 'keypress') {
            var code = event.charCode || event.keyCode;
            if ((code === 32) || (code === 13)) {
                return true;
            }
        } else {
            return false;
        }
    }
    function onPrefButtonClick (event) {
        if (isAccessibleClick(event)) {
            event.preventDefault();
            window.klaro.show();    
        }
    }
    // Enables all cookies for bots / trackers
    window.klaro.addEventListener('render', function (config) {
        if (!/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) {
            return; // only consent automatically for bots
        }
        var manager = window.klaro.getManager(config);
        manager.changeAll(true); // enable all trackers / third-party services for bots
        manager.saveAndApplyConsents();
    });
    // Show preferences panel when clicking the pref management button.
    var prefButton = document.getElementById('klaroPrefs');
    if (prefButton) {
        prefButton.addEventListener('click', onPrefButtonClick);
        prefButton.addEventListener('keydown', onPrefButtonClick);
    }
})();
//Accessibility fix: Tab trap on settings
document.addEventListener('DOMContentLoaded', function() {
    const openModalLink = jq('.cn-learn-more, #klaroPrefs');
    openModalLink.click(function(){
        waitForElm('.cm-modal').then(() => {
            const modal = jq('.cm-modal');
            modal.attr('tabindex', '0');
            modal.focus();
            
            const focusableElements = 'a, button:not(.hide), input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
            const firstFocusableElement = modal.find(focusableElements).first();
            const lastFocusableElement = modal.find(focusableElements).last();
            
            firstFocusableElement.on('keydown', function(e) {
                if (e.shiftKey && e.keyCode == 9){
                    e.preventDefault();
                    lastFocusableElement.focus();
                } 
            });
            lastFocusableElement.on('keydown', function(e) {
                if (!e.shiftKey && e.key === 'Tab') {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }
            });
        });
    });
});